<template>
  <div class="components_warp">
        <div class="top-container">
          
          <div v-for="(topic, index) in topics" :key="index">
            <div class="" v-if="index == curIndex">
              <div class="text_bewrite2">
                <p>
                  {{ topic.topic }}
                </p>
                <div class="q-answer q-shu2-answer">图中？处应填数字<input class="partBAnswer" type="text" readonly></div>
              </div>
              <!-- <section class="light">
                <label v-for="(b, index) in a.danxuan" :key="index">
                  <input type="radio" name="light" />
                  <span class="design"></span>
                  <span class="text">{{ b.name }}</span>
                </label>
              </section> -->
              <!-- <label>
                <p>答案:<span>(</span> <input type="text" placeholder="请输入" v-model="curAnswer" style="border:none;outline: none;display: inline-block;width:50px;font-weight: 600;
    font-size: 16px;"><span>)</span></p>
              </label> -->
            <div class="math-keyword">
              <span @click="answerSelect(1)">1</span>
              <span @click="answerSelect(2)">2</span>
              <span @click="answerSelect(3)">3</span>
              <!-- <span @click="answerClickB($event)">确定</span> -->
              <span @click="answerDelete($event)">回退</span>
              <span @click="answerSelect(4)">4</span>
              <span @click="answerSelect(5)">5</span>
              <span @click="answerSelect(6)">6</span><br>
              <span @click="answerSelect(7)">7</span>
              <span @click="answerSelect(8)">8</span>
              <span @click="answerSelect(9)">9</span><br>
              <span @click="answerSelect('-')">-</span>
              <span @click="answerSelect(0)">0</span>
              <span @click="answerSelect('/')">/</span>
            </div>
            </div>
          </div>
        </div>
        <div class="btn_warp" v-show="isShowBtn">
          <!-- <button><router-link to="/yuyanbiaodadati">确定</router-link></button> -->
          <span></span>
          <button @click="answerClickB($event)">确定</button>
          <span
            ><em>{{ curIndex + 1 }}</em
            >/{{ topics.length }}</span
          >

        </div>
        <div class="btn_warp" v-show="isHideBtn">
          <!-- <button><router-link to="/yuyanbiaodadati">确定</router-link></button> -->
          <span></span>
          <button @click="nextClick($event)">继续做答</button>
          <button @click="nextClick2($event)">进入下一题</button>
          <span
            ><em>{{ curIndex + 1 }}</em
            >/{{ topics.length }}</span
          >
        </div>
  </div>
</template>

<script>
export default {
 data() {
    return {
     
      startTimeA: '',
      startTimeB: '',
      startTime:'',
      endTime:'',
      clearTime:'',
      tempTime:'',
      curTempTime:'',
      curIndex: 0,
      topics:[],
      answers:[],
      curAnswer:'', //当前答案
      url:{path:'/careerevalution/home',query: { name:'znsp',part:'znsp53'}},
      isShowBtn:true,
      isHideBtn:false
    };
  },
  created(){
    this.getTopicApi()
    // this.clockStart()
  },
  mounted(){
   this.startTime = new Date().getTime();
   // this.end = Date.parse(new Date()) + 1080000 // 截止时间为7分钟（1min为60000ms,）
    
  },
  destroyed(){
   
  },
  methods: {
    clockStart: function () {
        var _this = this;
        this.t=setInterval(function () {
          if (_this.leftTime > 0) {
            _this.leftTime--;
            _this.secondToMin(_this.leftTime);
          } else if (_this.leftTime == 0) {
          
            _this.answerClickB('auto');
          }
        }, 1000)
      },


       /**
       * 秒转换为分钟格式
       */
      secondToMin: function (second) {
        var min, sec;
        if (second > 0) {
          sec = second % 60;
          min = parseInt(second / 60);
          if (sec < 10) {
            sec = '0' + sec;
          }
          this.timeTip = min + ':' + sec + '';
        }
      },

    getTopicApi(){
      this.$ajax.post(`${this.G_capi}${this.ports.careerEvaluation.znsp.sxnlList2}`,{},{
            headers:{
              token:sessionStorage.getItem('token')
            }
        })
        .then((res) => {
            this.topics = res.data.data
            console.log(this.topics)
        })
    },
    answerDelete: function (e) {
        var answer = $('.partBAnswer').val();
        var subLength = answer.length - 1;
        answer = answer.substring(0, subLength);
        $('.partBAnswer').val(answer);
      },
    answerSelect: function (value) {
        var answer = $('.partBAnswer').val();
        answer = answer + value;
        $('.partBAnswer').val(answer);
      },
    answerClickB: function (e) {
        var answer = $('.partBAnswer').val();
        if (e != 'auto' && answer == '') {
          this.layerMsg('请填写答案!');
          return false;
        }
        var question_id;
        if (e != 'auto') {
          question_id = $(e.target).closest('.ques-math2-answer').find('.ques-item').attr('cid');
        } else {
          question_id = $('.ques-item').attr('cid');
        }

        var time = Number(new Date().getTime()) - Number(this.tempTime);

        this.answers.push({
          questionId: this.topics[this.curIndex].id,
          time: time,
          answer: answer
        })
        this.tempTime = new Date().getTime();
   
        if (this.curIndex + 1 < this.topics.length) {
        this.curIndex++;
          clearInterval(this.t);
          this.leftTime = 180;
          this.timeTip = '3:00';
          this.clockStart();
          this.bar = Number(this.curIndexB) / Number(this.totalB) * 100;
      } else {
         clearInterval(this.t)
          this.t=null;
          this.endTimeB = new Date().getTime();//结束时间
          this.timeB = Number(this.endTimeB) - Number(this.startTimeB);
        this.saveNode(2,53,()=>{
          this.submit()
        })
      }


      },
  
    next() {
      if(this.curAnswer == ''){
        this.$message.error('请输入答案')
        return false
      }
       this.curTempTime = new Date().getTime();
      this.answers.push({
          questionId:this.topics[this.curIndex].id,
          time:this.curTempTime,
          answer:this.curAnswer
        })
      this.curAnswer = ""

      if (this.curIndex + 1 < this.topics.length) {
        this.curIndex++;
      } else {
        this.saveNode(2,53,()=>{
          this.submit()
        })
      }
    },
    submit(){ //提交
      this.endTime = new Date().getTime();//结束时间
      this.tempTime = Number(this.endTime) - Number(this.startTime);
      this.$ajax.post(`${this.G_capi}${this.ports.careerEvaluation.znsp.sxnlAdd2}`,{
          testId:sessionStorage.getItem('testId'),
          time:this.tempTime,
          answers:this.answers,
      },{
            headers:{
              token:sessionStorage.getItem('token')
            }
        })
        .then((res) => {
            var data = res.data;
          if(data.code==2000){
            this.$router.push({
              path: "/careerevalution/success",
              query: {
                type: "answer",
                url:this.url,
              },
            });
          }
        })
    },
  },
};
</script>

<style scoped>
.components_warp{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.wrapper {
  padding: 0 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.text_bewrite2 p{
  font-weight: 600;
  font-size: 16px;
  text-align: center;
}
.q-shu2-answer {
    text-align: center;
    font-size: 30px;
    font-weight: 700;
    line-height: 34px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 30px;
}
.q-shu2-answer input {
    width: 80px;
    height: 30px;
    border: 1px dashed red;
    border-radius: 3px;
    margin-left: 5px;
    margin-top: 3px;
    font-size: 20px;
    font-weight: 400;
    text-indent: .5rem;
}
.title h4 {
  font-size: 26px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.btn_warp {
  /* width: 70%;
    text-align: center;
    position: absolute;
    bottom:70px; */
  display: flex;
  justify-content: space-between;
}
/* 按钮 */
.btn_warp button {
  width: 166px;
  height: 41px;
  background: linear-gradient(90deg, #1fd99c 0%, #1ac6fd 100%);
  border-radius: 21px;
  border: none;
  color: #fff;
  font-size: 18px;
  margin: 40px auto 0;
  display: block;
}
label {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  margin: 12px 0;
  height: 40px;
  font-size: 16px;
  background: hsl(0, 0%, 98%);
  cursor: pointer;
  position: relative;
  border-radius: 8px;
}
.btn_warp em {
  font-style: normal;
  color: red;
}
.btn_warp span {
    font-size: 18px;
  /* position: relative;
    right: -250px; */
  display: block;
  flex: 1;
  text-align: right;
  margin-top: 40px;
  line-height: 41px;
}
.btn_warp button{
  margin-left: 10px;
}

.time {
  position: absolute;
  top: 40px;
  right: 40px;
  color: red;
}


</style>